import { render, staticRenderFns } from "./RequestsSelect.vue?vue&type=template&id=e0631ff0&"
import script from "./RequestsSelect.vue?vue&type=script&lang=js&"
export * from "./RequestsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports